import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-muti-right/style/index.js